<template>
  <v-dialog
    width="45vw"
    v-model="dialog"
    ref="dialog"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="dialog">
        <v-card-title>
          <v-toolbar
            elevation="0"
            style="background-color: transparent"
            class="d-flex align-center justify-center"
          >
            <v-row align="center" justify="center" dense
              ><span class="text-h4" style="color: #a826e1"
                >Criar um novo plano de ensino</span
              >
            </v-row>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.format"
                label="Modalidade"
                :items="formats"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.time"
                label="Tempo de aula"
                :items="times"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-select
                v-model="form.frequency"
                label="Frequência na semana"
                :items="frequencies"
                :item-text="`text`"
                :item-value="`value`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="value"
                label="Valor"
                placeholder="R$"
                :value="value"
                :hint="`O valor será de: ${
                  displayValue ?? 'R$'
                } mensais para o plano atual`"
              />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="discount"
                label="Desconto"
                placeholder="R$"
                :value="discount"
                :hint="`O desconto aplicado será de: ${
                  displayDiscount ?? 'R$'
                } no valor mensal`"
                :rules="rules.moreThen"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined color="warning-500" @click="closeDialog"
            >Cancelar</v-btn
          >
          <v-btn
            rounded
            outnlined
            color="secondary-500"
            class="white--text"
            @click="save"
          >
            Criar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  name: "PlanDialog",
  mixins: [],
  props: {},
  data() {
    return {
      dialog: false,
      valid: false,
      formats: [
        { text: "Individual", value: "INDIVIDUAL" },
        { text: "Dupla", value: "DUO" },
        { text: "Trio", value: "TRIO" },
        { text: "Quarteto ", value: "SQUAD" },
      ],
      times: [
        {
          text: "1 Hora",
          value: "1:00",
        },
        {
          text: "1 Hora e 30 minutos",
          value: "1:30",
        },
      ],
      frequencies: [
        { text: "Uma vez na semana", value: "ONCE" },
        { text: "Duas vezes na semana", value: "TWICE" },
      ],
      value: null,
      discount: null,
      displayValue: null,
      displayDiscount: null,
      form: {
        format: null,
        time: null,
        frequency: null,
      },
      rules: {
        moreThen: [
          (v) =>
            this.checkPrice(v) ||
            "Desconco não pode ser maior que o valor da mensalidade!",
        ],
      },
    };
  },
  computed: {},
  watch: {
    value(price) {
      if (price) {
        this.displayValue = Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(price);
      }
    },
    discount(value) {
      if (value) {
        this.displayDiscount = Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(value);
      }
    },
  },
  mounted() {},
  methods: {
    checkPrice(value) {
      return value <= this.value ? true : false;
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.value = null;
      this.discount = null;
      this.displayValue = null;
      this.displayDiscount = null;
      this.form = {
        format: null,
        time: null,
        frequency: null,
      };
      this.dialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$emit(
          "savePlan",
          this.form.id
            ? this.form
            : {
                ...this.form,
                value: Number(this.value),
                discount: Number(this.discount),
              }
        );
      }
    },
  },
};
</script>
<style scoped>
.dialog {
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 32px 0 rgba(70, 81, 228, 0.37);
  backdrop-filter: blur(7.5px);
  -webkit-backdrop-filter: blur(7.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>
